module.exports = __webpack_public_path__ + "img/图片10.c24e5d3b.png";